export default "__VITE_ASSET__BjXwkB$R__"